import { Button, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router";
import { usePageMeta } from "src/hooks/usePageMeta";
import { useT } from "src/i18n";

// Real 404 for unknown routes. Azure SWA can't tell a valid SPA deep link from
// a garbage URL at the edge, so the HTTP status stays 200 (navigationFallback
// serves index.html); the noindex meta is what keeps these URLs out of the
// index and removes the soft-404 / duplicate-content signal the old
// `Navigate to="/"` redirect produced. Keeping the user on the URL (instead of
// bouncing to "/") also tells them the link was wrong rather than silently
// dumping them on the homepage.
export default function NotFound() {
    const t = useT();
    usePageMeta({
        title: t("landing.notFound.pageTitle"),
        robots: "noindex,follow",
    });

    return (
        <Stack spacing={3} sx={{ alignItems: "center", textAlign: "center", py: { xs: 6, md: 10 } }}>
            <Typography variant="h3" component="h1" sx={{ fontWeight: 700 }}>
                404
            </Typography>
            <Typography variant="h6" component="p" sx={{ color: "text.secondary", maxWidth: 480 }}>
                {t("landing.notFound.heading")}
            </Typography>
            <Button size="large" variant="contained" color="warning" component={RouterLink} to="/">
                {t("landing.notFound.cta")}
            </Button>
        </Stack>
    );
}
